import { Classic } from './Classic';
import { Feed } from './Feed';

export const variations = {
  classic: Classic,
  feed: Feed
};
